import endpoints from "config/endpoints";
import { useCallback } from "react";
import useAxiosRequest from "./common/useAxiosRequest";

const useCep = () => {
  const { data, loading, error, run } = useAxiosRequest({ globalError: false });

  const getCep = useCallback(
    (cep) => {
      return run({ method: "GET", url: endpoints.cep(cep) });
    },
    [run]
  );

  return { data, loading, error, getCep };
};

export default useCep;
